import axios from 'axios';

export const getVendorList = ({
  name = '',
  tel = '',
  prefecture_name = '',
  address = '',
  partner_type_large_id = 0,
  partner_type_small_id = 0,
  partner_type_detail_id = 0,
  rank_id = 0,
  current_page = 0,
  display_limit = 0
} = {}) => {
  const url =
    '/api/v1/vendors?' +
    `name=${name}` +
    `&tel=${tel}` +
    `&prefecture_name=${prefecture_name}` +
    `&address=${address}` +
    `&partner_type_large_id=${partner_type_large_id}` +
    `&partner_type_small_id=${partner_type_small_id}` +
    `&partner_type_detail_id=${partner_type_detail_id}` +
    `&rank_id=${rank_id}` +
    `&page=${current_page}` +
    `&display_limit=${display_limit}`;
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getVendorTypeSmall = () => {
  return axios
    .get(`/api/v1/partner-category/filtering/categories`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getVendorTypeLarge = () => {
  return axios
    .get(`/api/v1/get/vendor/large/types`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getVendorRank = () => {
  return axios
    .get(`/api/v1/get/vendor/ranks`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteVendor = (id: any) => {
  return axios
    .post(
      `/api/v1/delete/vendors`,
      {
        vendors_list: id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getRounding = () => {
  return axios
    .get(`/api/v1/get/roundings`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPaymentSite = () => {
  return axios
    .get(`/api/v1/get/payment/sites`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getIndustryTypes = () => {
  return axios
    .get(`/api/v1/partner-category/master`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const saveVendor = (
  partner_type_large: number | undefined,
  partner_type_small: any,
  business_types: any,
  name: string,
  furigana: string,
  rep_name: string,
  capital: number | undefined,
  no_of_employees: number | undefined,
  establish_month: number | undefined,
  prefecture: number | undefined,
  address1: string,
  address2: string,
  address3: string,
  tel: number | string,
  fax: string,
  bank_name: string,
  bank_branch: string,
  account_type: number | undefined,
  account_number: number | undefined | string,
  account_name: string,
  end_day: number | undefined,
  payment_site_month: string,
  payment_site_date: string,
  rounding: number | undefined,
  person_in_charge_name: string,
  person_in_charge_tel: string,
  person_in_charge_email: string,
  remarks: string,
  rank_id: number | undefined
) => {
  return axios
    .post(
      `/api/v1/vendors`,
      {
        partner_type_large,
        partner_type_small,
        business_types,
        name,
        furigana,
        rep_name,
        capital,
        no_of_employees,
        establish_month,
        prefecture,
        address1,
        address2,
        address3,
        tel,
        fax,
        bank_name,
        bank_branch,
        account_type,
        account_number,
        account_name,
        end_day,
        payment_site_month,
        payment_site_date,
        rounding,
        person_in_charge_name,
        person_in_charge_tel,
        person_in_charge_email,
        remarks,
        rank_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getVendorDetailsById = (id: number) => {
  return axios
    .get(`/api/v1/vendors/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateVendorDetails = (
  id: number,
  partner_type_large: number | undefined,
  partner_type_small: any,
  business_types: any,
  name: string,
  furigana: string,
  rep_name: string,
  capital: number | undefined,
  no_of_employees: number | undefined,
  establish_month: number | undefined,
  prefecture: number | undefined,
  address1: string,
  address2: string,
  address3: string,
  tel: number | string,
  fax: string,
  bank_name: string,
  bank_branch: string,
  account_type: number | undefined,
  account_number: number | undefined | string,
  account_name: string,
  end_day: number | undefined,
  payment_site_month: string,
  payment_site_date: string,
  rounding: number | undefined,
  person_in_charge_name: string,
  person_in_charge_tel: string,
  person_in_charge_email: string,
  remarks: string,
  rank_id: number | undefined
) => {
  return axios
    .put(
      `/api/v1/vendors/${id}`,
      {
        partner_type_large,
        partner_type_small,
        business_types,
        name,
        furigana,
        rep_name,
        capital,
        no_of_employees,
        establish_month,
        prefecture,
        address1,
        address2,
        address3,
        tel,
        fax,
        bank_name,
        bank_branch,
        account_type,
        account_number,
        account_name,
        end_day,
        payment_site_month,
        payment_site_date,
        rounding,
        person_in_charge_name,
        person_in_charge_tel,
        person_in_charge_email,
        remarks,
        rank_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getIndustryNamesFromIds = (
  partner_categories: any,
  partner_category_details: any
) => {
  return axios
    .post(
      `/api/v1/get/partner-category/names`,
      {
        partner_categories,
        partner_category_details
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const getExportVendorItems = (
  selected_columns: any,
  name: string,
  tel: string,
  prefecture_name: string,
  address: string,
  partner_type_large_id: number,
  partner_type_small_id: number,
  rank_id: number
) => {
  return axios
    .post(
      `/api/v1/export/vendors/list?name=${name}&tel=${tel}&prefecture_name=${prefecture_name}&address=${address}&partner_type_large_id=${partner_type_large_id}&partner_type_small_id=${partner_type_small_id}&rank_id=${rank_id}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getVendorUserById = (id: number) => {
  return axios
    .get(`/api/v1/get/vendor/outside_partner/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
